var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CE21E30A-D48C-493F-A614-0E659840D9AF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-201.000000, -135.000000)",
    fill: "#46B39A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(20.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-discount-5007189",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32707581,7.71263538 C5.95760289,7.34259928 5.95760289,6.74101083 6.32707581,6.37097473 C6.51237545,6.18567509 6.755213,6.09373285 6.99776895,6.09373285 C7.24032491,6.09373285 7.48344404,6.18623827 7.66846209,6.37097473 C8.03849819,6.74101083 8.03849819,7.34259928 7.66846209,7.71263538 C7.2981444,8.08238989 6.69741516,8.08238989 6.32709025,7.71263538 L6.32707581,7.71263538 Z M19.9126354,10.00787 C19.9126354,15.5028159 15.4584116,19.9566065 9.96389892,19.9566065 C4.46895307,19.9566065 0.0151624549,15.5023827 0.0151624549,10.00787 C0.0151624549,4.51292419 4.46916968,0.059133574 9.96389892,0.059133574 C15.4586282,0.059133574 19.9126354,4.51314079 19.9126354,10.00787 L19.9126354,10.00787 Z M5.46931408,8.5700361 C5.8906787,8.99140072 6.44404332,9.20208664 6.99768953,9.20208664 C7.55133574,9.20208664 8.10469314,8.99140072 8.52606498,8.5700361 C9.36909747,7.72729242 9.36909747,6.35602888 8.52606498,5.5132852 C7.6833213,4.67025271 6.31205776,4.67054152 5.46931408,5.5132852 C4.62714801,6.35602888 4.62714801,7.72700361 5.46931408,8.5700361 Z M14.4981949,6.33090253 L13.6405054,5.473213 L5.74231047,13.3714079 L6.6,14.2290975 L14.4981949,6.33090253 Z M14.4581451,11.4454152 C13.6154014,10.6023827 12.2435603,10.6023827 11.4011054,11.4454152 C10.5580729,12.2881588 10.5580729,13.6594224 11.4011054,14.5024549 C11.82247,14.9238195 12.3758347,15.1339422 12.9294809,15.1339422 C13.4831271,15.1339422 14.0364845,14.9232563 14.4578563,14.5018917 C15.3011776,13.6594368 15.3011776,12.2884621 14.4581383,11.4454296 L14.4581451,11.4454152 Z M13.6004556,12.3033935 C13.415156,12.1180939 13.1723184,12.0261516 12.9297625,12.0261516 C12.6866433,12.0261516 12.4440874,12.118657 12.2590693,12.3033935 C11.8890332,12.6728664 11.8890332,13.2750181 12.2590693,13.6450542 C12.6285422,14.0145271 13.2309827,14.0150903 13.60073,13.6450542 C13.9704773,13.2750181 13.9704845,12.672852 13.6004479,12.3033935 L13.6004556,12.3033935 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.d203358593ac744a61ff6592624cb8f7.svg";
export { ForwardRef as ReactComponent };